<template lang="pug">
    .fixedHeader(ref="fixedHeader")
        .container
            .left
                img.logo(:src="require('@/assets/img/calendarLogo/logo_with_text_'+$i18n.locale+'.png')" v-anchor="'.home'")
                app-header
            slot
</template>

<script>
    import Header from "./Header";
    import MonthsList from "../elements/MonthsList";
    export default {
        name: "HomeFixedHeader",
        methods:{
            iniFixedtHeader() {
                let fixedHeader = document.querySelector('.fixedHeader'),
                    headHeight = document.querySelector('.home .head').scrollHeight;

                let handler = (offset) => {
                    if (getComputedStyle(document.querySelector('#app')).position === 'fixed') return;
                    if (offset > headHeight * 0.8){
                        if (!fixedHeader.classList.contains('show')){
                            fixedHeader.classList.add('show');
                        }
                    }else {
                        fixedHeader.classList.remove('show');
                    }
                };

                window.addEventListener('scroll', () => {
                    handler(window.pageYOffset)
                })
            }
        },
        mounted(){
            this.iniFixedtHeader();
        },
        components: {MonthsList, appHeader: Header}
    }
</script>

<style scoped lang="scss">
    .fixedHeader{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100vw;
        background: #054281;
        box-shadow: 0 0 14px #093463;
        transform: translate3d(0, -100%, 0);
        transition: .5s;
        &.show {
            transform: translate3d(0, 0, 0);
        }
        .container{
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 102rem;
        }
        .left{
            display: flex;
            align-items: center;
            .logo{
                width: 12.5rem;
                margin-right: 0.85rem;
                cursor: pointer;
            }
            header{
                position: static;
                width: auto;
                padding: 0;
                &::v-deep{
                    nav{
                        font-size: 1.1rem;
                        & > a{
                            &:not(:first-child) {
                                margin-left: 1vw;
                            }
                            &.active:before{
                                left: -0.7rem;
                                right: -0.7rem;
                            }
                        }
                    }
                }
            }
        }
        .monthsList{
            width: 21.4rem;
            margin-right: 0.7rem;
        }
        @include razr1600{
            .monthsList::v-deep{
                .arrow.left{
                    right: calc(100% - 1rem);
                }
                .arrow.right{
                    left: calc(100% - 1rem);
                }
            }
        }
        @include razr1023{
            padding: 0.5rem 0 0.5rem;
        }
        @include razr767{
            padding: 20px 0;
        }
        @include mobile_or_P{
            .container{
                flex-direction: row-reverse;
            }
            .left{
                .logo{
                    display: none;
                }
                header{
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }
            .monthsList::v-deep{
                margin-left: 1rem;
                .arrow{
                    &.left{
                        right: 98%;
                    }
                    &.right{
                        left: 98%;
                    }
                }
                .list{
                    /*width: 19rem;*/
                    .month{
                        &.active{
                            font-size: 2.3rem;
                        }
                    }
                }
            }
        }
    }
</style>
